function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
Promise.all([import('../classes/page-filters')]).then(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 1),
    modulePageFilters = _ref2[0];
  // Define the components
  var PageFiltersController = modulePageFilters["default"];

  // Find the page
  var page = document.querySelector('.js-quarries');
  // Find the search list
  var list = document.querySelector('.js-quarries__list');
  // Find the search form
  var form = document.querySelector('.js-quarries__form');
  // Find the search results
  var results = document.querySelector('.js-quarries__results');

  // The pagination selector
  var LOAD_MORE_SELECTOR = '.js-quarries__load-more';
  // The pagination parameter
  var LOAD_MORE_PARAMETER = 'start';
  if (!form) return;

  // Create a new FilterController
  var PageFilters = new PageFiltersController(form);

  // A var to determine if the page is loading more or replacing the results
  var LOADING_MORE = false;
  // The load more button
  var loadmore = page.querySelector(LOAD_MORE_SELECTOR);

  /* ----------------------------------
  Functions
  ---------------------------------- */

  var addNewInputs = function addNewInputs() {
    // Find the load more button
    loadmore = page.querySelector(LOAD_MORE_SELECTOR);

    // If there is no limit, return
    if (!loadmore) return;

    // When the load more button is clicked
    loadmore.addEventListener('click', function (e) {
      // Prevent the default action
      e.preventDefault();
      if (e.target.tagName === 'BUTTON') {
        // Set loading more to true
        LOADING_MORE = true;
        // Set the page number
        PageFilters.add(LOAD_MORE_PARAMETER, e.target.value);
        // Submit the filters
        PageFilters.submit();
      }
    });
  };

  /* ----------------------------------
  Document setup
  ---------------------------------- */

  // When the form is submitted
  PageFilters.on('submit', function () {
    // Add a spinner class to the list
    list.classList.add('spinner');
    if (!LOADING_MORE) {
      // Add a loading class to the results if we're not loading more
      list.classList.add('loading');
      // Smooth scroll the page to the top of the results
      window.scrollTo({
        top: results.offsetTop - 200,
        behavior: 'smooth'
      });
    }
  });

  // When the filter is applied and loads successfully
  PageFilters.on('success', function (response) {
    // Remove the button
    if (loadmore) loadmore.remove();
    // If we're not loading more clear the results
    if (!LOADING_MORE) results.innerHTML = '';
    // Append the results to the list
    results.innerHTML += response;
    // Set the loading more var to false
    LOADING_MORE = false;
  });

  // PageFilters.on('pageChanged', () => {
  //   window.ScrollController.scrollTo(window.getOffsetY(results) - 200, 500);
  // });

  // When the filter is applied but there is an error
  PageFilters.on('error', function (response) {
    // Tell the user there was an error
    console.warn('There was an error loading the results. Error code:', response);
    results.innerHTML = "<p class=\"text-center\">There was an error loading the results.</p>";
  });

  // When the page filters have completed
  PageFilters.on('complete', function () {
    // Remove the page parameter from the filter
    PageFilters.remove(LOAD_MORE_PARAMETER);

    // Remove all the loading classes
    list.classList.remove('loading', 'spinner');

    // Add the new inputs
    addNewInputs();
  });
  addNewInputs();
})["catch"](function (error) {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});